import Splide from '../lib/_splide_4-1-4.esm';

// Turns a Hero partial's image gallery into an accessible slider.
// Only mounted when a Hero partial actually renders a `.hero-slider` element,
// i.e. when 2+ images are set in the page properties (see Hero1-4.html).
$(document).ready(function () {
    document.querySelectorAll('.hero-slider').forEach(function (el) {
        new Splide(el, {
            type: 'loop',
            arrows: true,
            pagination: false,
            drag: true,
            autoplay: true,
            pauseOnHover: true,
            pauseOnFocus: true,
            speed: 600,
            // Splide's `reducedMotion` default (speed: 0, autoplay: 'pause')
            // already respects prefers-reduced-motion.
            i18n: {
                prev: 'Vorheriges Bild',
                next: 'Nächstes Bild',
                first: 'Zum ersten Bild springen',
                last: 'Zum letzten Bild springen',
                slideX: 'Zu Bild %s springen',
                pageX: 'Zu Seite %s springen',
                play: 'Automatischen Bildwechsel starten',
                pause: 'Automatischen Bildwechsel anhalten',
                carousel: 'Bildergalerie',
                slide: 'Bild',
                select: 'Bild auswählen',
                slideLabel: '%s von %s',
            },
        }).mount();
    });
});
